import { useCallback } from 'react';
import { LocalStorageService } from '#service';

export const useUpdateLocalStorageFilterParam = disableSync => {
  const getNewLocalStorageData = useCallback(({ value, name, id }) => {
    const localStorageFilter = LocalStorageService.getItem('listFilter') ?? {};

    // Do not save to the local storage if not allowed sync.
    if (disableSync) {
      return localStorageFilter;
    }

    if (!localStorageFilter[id]) {
      localStorageFilter[id] = {};
    }
    if (!localStorageFilter[id][name]) {
      localStorageFilter[id][name] = {};
    }

    localStorageFilter[id][name].value = value;

    return localStorageFilter;
  }, [disableSync]);

  return useCallback(({ value, name, id }) => {
    const newFilter = getNewLocalStorageData({ value, name, id });
    LocalStorageService.setItem('listFilter', newFilter);
  }, [getNewLocalStorageData]);
};
